import {
  PartnershipRequestInvoker,
  SupplierRequestInvoker,
  type PartnershipScope,
} from '@purchase/supplier';
import camelCaseKeys from 'camelcase-keys';

const excludeFields = [/isKOLForMCN/];

export const initializeSupplierRequestInvoker = (
  solarInvoke: (opts: {
    api?: string;
    param?: string;
  }) => Promise<{ data?: any } | undefined>,
  userInfo: {
    id: number;
    name: string;
    mail: string;
    jobnumber: string;
  }
) => {
  // 初始化中台供应商请求调用器，并且设置操作人信息
  SupplierRequestInvoker.initialize((data) =>
    solarInvoke(data, { camelCase: { exclude: excludeFields } })
  ).setOperator({
    id: userInfo?.id,
    name: userInfo?.name,
    mail: userInfo?.mail,
    jobNumber: userInfo?.jobnumber,
  });
};

export const initializePartnershipRequestInvoker = (
  request: (opts: {
    api?: string;
    param?: string;
  }) => Promise<{ data?: any } | undefined>,
  nonAuthRequest: (opts: {
    api?: string;
    param?: string;
  }) => Promise<{ data?: any } | undefined>
) => {
  PartnershipRequestInvoker.initialize((data) => 
    request(data, { camelCase: { exclude: excludeFields } })
  ).setNonauthRequest(((data) => 
    nonAuthRequest(data, { camelCase: { exclude: excludeFields } })
  ))
  PartnershipRequestInvoker.getInstance().setScope('mpc' as PartnershipScope)
};
